<template>
  <div class="outStock column-me">
    <div class="card-div column-me flex1">
      <div class="row-me row-center">
        <div class="width250">
          <el-select v-model="selectHouse" placeholder="请选择库房" style="width: 100%;" filterable clearable>
            <el-option v-for="item in houseArray" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="width250 margin-left20">
          <el-select v-model="selectType" placeholder="请选择类型" style="width: 100%;" filterable clearable>
            <el-option v-for="item in typeArray" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="width500 margin-left20">
          <el-date-picker type="daterange" range-separator="至" start-placeholder="入库日期(从)"
                          end-placeholder="入库日期(到)" value-format="YYYY-MM-DD" style="width: 100%;" clearable
                          v-model="selectDate">
          </el-date-picker>
        </div>
        <div class="width250 margin-left20">
          <el-input placeholder="请输入出库单号" style="width: 100%;" clearable v-model="orderNum"></el-input>
        </div>
        <div class="flex1"></div>
        <div class="btn-blue width100 btn-height40 margin-left20" @click="clickSearch">
          <el-icon>
            <search/>
          </el-icon>
          查询
        </div>
        <div class="btn-blank width100 btn-height40 margin-left20" @click="clickClear">清空</div>
      </div>
      <div class="row-me row-center margin-top30" v-if="canOperate">
        <div class="btn-blue width160 btn-height40" @click="clickAdd">
          <el-icon>
            <plus/>
          </el-icon>
          新建出库单据
        </div>
      </div>
      <div class="column-me flex1 margin-top20">
        <div class="flex1">
          <el-table ref="tableOutStock" :data="tableData" border header-cell-class-name="table-header-style"
                    cell-class-name="table-cell-style" @row-click="clickTableRow">
            <el-table-column type="expand">
              <template #default="scope">
                <div class="margin-left15 margin-right15">
                  <el-table :data="scope.row.details" border header-cell-class-name="table-header-style"
                            cell-class-name="table-cell-style" height="100%">
                    <el-table-column prop="drugName" label="药品名称" align="center"
                                     show-overflow-tooltip></el-table-column>
                    <el-table-column prop="spec" label="规格" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="unitName" label="单位" align="center"
                                     show-overflow-tooltip></el-table-column>
                    <el-table-column prop="batchNo" label="批号" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="validityTime" label="有效期" align="center" width="130"
                                     show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="nums" label="申请数量" align="center"
                                     show-overflow-tooltip></el-table-column>
                    <el-table-column prop="costPrice" label="成本价" align="center"
                                     show-overflow-tooltip></el-table-column>
                    <el-table-column prop="totalPrice" label="总价" align="center"
                                     show-overflow-tooltip></el-table-column>
                    <el-table-column prop="produceTime" label="生产日期" align="center" width="130"
                                     show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="producerName" label="生厂商" align="center" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="productAddress" label="产地" align="center" show-overflow-tooltip>
                    </el-table-column>
                  </el-table>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="单据编号" align="left" width="200" show-overflow-tooltip>
              <template v-slot="scope">
                <div class="blue-text">{{ scope.row.batchNo }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="pharmacyName" label="库房名称" align="left" show-overflow-tooltip></el-table-column>
            <el-table-column prop="typeName" label="类型" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="createTime" label="创建时间" align="left" width="220"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="createBy" label="创建人" align="center" width="100"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="updateTime" label="执行时间" align="left" width="220"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="updateBy" label="执行人" align="center" width="100"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="name" label="状态" align="center" width="100" show-overflow-tooltip>
              <template v-slot="scope">
                <div class="text-green" v-if="scope.row.status.value===0">{{ scope.row.status.name }}
                </div>
                <div class="text-green" v-if="scope.row.status.value===1">{{ scope.row.status.name }}
                </div>
                <div class="text-orange" v-if="scope.row.status.value===2">{{ scope.row.status.name }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="remark" label="备注" align="center" show-overflow-tooltip>
              <template #default="scope">
                <div class="line3" :title="scope.row.remark">{{ scope.row.remark }}</div>
              </template>
            </el-table-column>
            <el-table-column label="操作列" align="left" width="300" v-if="canOperate">
              <template v-slot="scope">
                <div class="row-me row-center pointer">
                  <div class="text-blue margin-right20" v-if="scope.row.status.value===0"
                       @click.stop="clickDone(scope.row)">执行
                  </div>
                  <div class="text-blue margin-right20" v-if="scope.row.status.value===0
                       &&scope.row.typeName.indexOf('调拨')===-1&&scope.row.typeName.indexOf('盘盈')===-1
                       &&scope.row.typeName.indexOf('盘亏')===-1"
                       @click.stop="clickEdit(scope.row)">修改
                  </div>
                  <div class="text-red margin-right20" v-if="scope.row.status.value===0"
                       @click.stop="clickDelete(scope.row)">删除
                  </div>
                  <div class="text-blue margin-right20" @click.stop="clickPrint(scope.row)">打印</div>
                  <div class="text-blue" @click.stop="clickExport(scope.row)">导出</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="操作列" align="center" width="160" v-else>
              <template v-slot="scope">
                <div class="row-me center-all pointer">
                  <div class="text-blue margin-right20" @click.stop="clickPrint(scope.row)">打印</div>
                  <div class="text-blue" @click.stop="clickExport(scope.row)">导出</div>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="margin-top20">
          <el-pagination background @current-change="handleCurrentChange" :current-page.sync="pageNo"
                         layout="total, prev, pager, next" :total="total">
          </el-pagination>
        </div>
      </div>
    </div>


    <!-- 新增出库单据 -->
    <el-dialog title="新增出库单据" v-model="visibleEdit" width="90%" top="5vh" :destroy-on-close="true">
      <div class="dialog-content column-me">
        <div class="row-me row-center">
          <div class="row-me row-center">
            <div><span class="red-star">*</span>库房：</div>
            <div class="width500">
              <el-select placeholder="请选择库房" style="width: 100%;" filterable clearable
                         v-model="selectStock" @change="houseChange"
                         :class="{'red-border':showRedBorder&&(selectStock===''||selectStock===null)}">
                <el-option v-for="item in houseArray" :key="item.id" :label="item.name"
                           :value="item.id">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="row-me row-center margin-left150">
            <div><span class="red-star">*</span>出库类型：</div>
            <div class="width500">
              <el-select placeholder="请选择出库类型" style="width: 100%;" filterable clearable
                         v-model="selectStockType"
                         :class="{'red-border':showRedBorder&&(selectStockType===''||selectStockType===null)}">
                <el-option v-for="item in typeArray" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div class="row-me margin-top20">
          <div><span class="red-star-div"></span>备注：</div>
          <div class="flex1">
            <el-input placeholder="请输入备注" type="textarea" style="width: 100%;" clearable v-model="remark"
                      maxlength="200">
            </el-input>
          </div>
        </div>
        <div class="row-me row-center margin-top20">
          <div><span class="red-star-div"></span>药品：</div>
          <el-popover placement="bottom-start" width="1000px" trigger="manual" :visible="medicineVisible">
            <el-table :data="list" border header-cell-class-name="table-header-style"
                      cell-class-name="table-cell-style" height="40vh" @row-click="clickRow">
              <el-table-column property="name" label="药品名称" align="center" show-overflow-tooltip
                               width="150"></el-table-column>
              <el-table-column property="spec" label="规格" align="center" show-overflow-tooltip></el-table-column>
              <el-table-column property="batchNo" label="批号" align="center" width="250"
                               show-overflow-tooltip></el-table-column>
              <el-table-column property="costPrice" label="上次进价" align="center" width="120">
              </el-table-column>
              <el-table-column property="normalPrice" label="常规价" align="center"></el-table-column>
              <el-table-column property="granulePrice" label="颗粒价" align="center"></el-table-column>
              <el-table-column property="pyName" label="简码" align="center"></el-table-column>
            </el-table>
            <template #reference>
              <el-input class="width400" placeholder="请选择药品名称" v-model="medicine" @input="inputChange"
                        @focus="inputChange" @blur="inputBlur">
              </el-input>
            </template>
          </el-popover>
        </div>
        <div class="column-me margin-top20">
          <div class="table-border">
            <el-table :data="drugList" border header-cell-class-name="table-header-style"
                      cell-class-name="table-cell-style" height="50vh">
              <el-table-column prop="drugName" label="药品名称" align="center" width="120"
                               show-overflow-tooltip></el-table-column>
              <el-table-column prop="spec" label="规格" align="center" show-overflow-tooltip
                               width="120"></el-table-column>
              <el-table-column prop="batchNo" label="批号" align="center" show-overflow-tooltip
                               width="300"></el-table-column>
              <el-table-column prop="validityTime" label="有效期" align="center" width="130"></el-table-column>
              <el-table-column prop="avaNums" label="库存" align="center" width="100"></el-table-column>
              <el-table-column align="center" width="130">
                <template #header>
                  <div>申请数量<span class="red-star">*</span></div>
                </template>
                <template #default="scope">
                  <div class="row-me center-all">
                    <div class="width100" :title="scope.row.nums">
                      <el-input placeholder="请输入" style="width: 100%;" clearable
                                v-model="scope.row.nums" @input="priceChange(1)">
                      </el-input>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="unitName" label="单位" align="center" width="100"></el-table-column>
              <el-table-column prop="costPrice" label="成本价" align="center" width="100"></el-table-column>
              <el-table-column prop="totalPrice" label="总价" align="center" width="100"></el-table-column>
              <el-table-column prop="produceTime" label="生产日期" align="center" width="130">
              </el-table-column>
              <el-table-column prop="producerName" label="生产商" align="center"
                               show-overflow-tooltip></el-table-column>
              <el-table-column prop="productAddress" label="产地" align="center"
                               show-overflow-tooltip></el-table-column>
              <el-table-column label="操作" align="center" width="100">
                <template v-slot="scope">
                  <div class="row-me center-all pointer" @click="clickDeleteItem(scope.$index)">
                    <div class="text-blue">删除</div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="flex1"></div>
        <div class="row-me row-center flex-end1 margin-top20">
          <div class="btn-blue width140 btn-height40" @click="clickSave">保存</div>
        </div>
      </div>
    </el-dialog>

    <!-- 打印单据 -->
    <div v-show="false">
      <printStock ref="printPage" title="出库单" :id="selectId"></printStock>
    </div>
  </div>
</template>

<script>
import printStock from './printStock.vue'

export default {
  components: {
    printStock
  },
  data() {
    return {
      name: '',
      selectHouse: '',
      houseArray: [],
      selectType: '',
      typeArray: [],
      selectDate: [],
      orderNum: '',
      tableData: [],
      pageNo: 1,
      total: 0,
      visibleEdit: false,
      // 以下弹窗
      selectStock: '',
      selectStockType: '',
      remark: '',
      medicineVisible: false,
      medicine: '',
      list: [],
      drugList: [],
      showRedBorder: false,
      selectId: '', //选择的出库单ID，用于修改
      canOperate: false,//是否可操作
    }
  },
  // html加载完成之前
  created() {
    this.$getMenuOperateAuth(this.$route.path).then(res => {
      this.canOperate = res.data
    })
    this.getHouseList()
    this.getOutStorageType()
    this.pageNo = 1
    this.getData()
  },
  // html加载完成后执行。
  mounted() {

  },
  // 事件方法执行
  methods: {
    houseChange(e) {
      this.drugList = []
    },
    clickTableRow(row, index, e) {
      this.$refs.tableOutStock.toggleRowExpansion(row)
    },
    //搜索
    clickSearch() {
      this.pageNo = 1
      this.getData()
    },
    //清空
    clickClear() {
      this.selectHouse = ''
      this.selectType = ''
      this.selectDate = []
      this.orderNum = ''
      this.pageNo = 1
      this.getData()
    },
    //新增
    clickAdd() {
      this.selectId = ''
      this.selectStock = ''
      this.selectStockType = ''
      this.remark = ''
      this.medicine = ''
      this.drugList = []
      this.showRedBorder = false
      this.visibleEdit = true
    },
    //编辑
    clickEdit(item) {
      this.selectId = item.id
      this.selectStock = item.pharmacyId
      this.selectStockType = item.type
      this.remark = item.remark
      this.drugList = item.details
      this.visibleEdit = true
    },
    //执行
    clickDone(item) {
      this.$confirm("您确定要执行吗？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$postFormRequest('/admin/stock/actionOutStorage/' + item.id).then((res) => {
          if (res) {
            this.$message.success(res.message)
            this.getData()
          }
        }).catch((error) => {
          console.log(error)
        })
      }).catch(() => {
      });
    },
    //删除
    clickDelete(item) {
      this.$confirm("您确定要删除吗？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$postRequest('/admin/stock/deleteOutStorage', [item.id]).then((res) => {
          if (res) {
            this.$message.success(res.message)
            this.pageNo = 1
            this.getData()
          }
        }).catch((error) => {
          console.log(error)
        })
      }).catch(() => {
      });
    },
    //打印
    clickPrint(item) {
      let that = this
      this.selectId = item.id
      setTimeout(() => {
        that.$refs.printPage.getDetail()
      }, 500)
    },
    //导出
    clickExport(item) {
      let token = sessionStorage.getItem('token')
      let param = {
        id: item.id,
        token: token,
      }
      let url = this.$baseUrl + '/admin/stock/exportOutStorage?' + this.$method.getParamsString(param)
      window.open(url)
    },
    //页数改变
    handleCurrentChange(pageNo) {
      this.pageNo = pageNo
      this.getData()
    },
    //点击药品下拉
    clickRow(row, column, e) {
      this.medicine = '' //赋值输入框
      this.medicineVisible = false //隐藏搜索下拉
      if (this.contains(this.drugList, row)) {
        this.$message.error('不能添加重复药品')
      } else {
        this.drugList.push(row) //添加到表格
      }
    },
    //处方药品输入框失去焦点隐藏药品下拉
    inputBlur() {
      this.medicineVisible = false
    },
    //处方选择药品输入框
    inputChange() {
      //动态搜索药品
      let that = this
      if (this.selectStock === '') {
        this.$message.error('请先选择库房')
        this.medicine = ''
        return
      }
      if (this.medicine === '') {
        return
      }
      this.$getRequest('/admin/stock/getOutPharmacyDrug', {
        pharmacyId: this.selectStock,
        drugName: this.medicine,
      }).then((res) => {
        if (res) {
          this.list = res.data
          this.medicineVisible = this.list.length > 0
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    contains(a, obj) {
      for (let i = 0; i < a.length; i++) {
        if (a[i].drugId === obj.drugId && a[i].batchNo === obj.batchNo) {
          return true;
        }
      }
      return false;
    },
    //删除某一项
    clickDeleteItem(index) {
      this.drugList.splice(index, 1)
    },
    //成本价、数量、总价联动
    priceChange(type) {
      for (let item of this.drugList) {
        if (type === 1) {
          item.nums = this.$method.checkInput(item.nums, 0)
          if (!this.$method.isEmptyOrZero(item.nums) && !this.$method.isEmptyOrZero(item.costPrice)) {
            item.totalPrice = this.$method.toFixed(item.costPrice * item.nums, 3)
          }
        } else if (type === 2) {
          item.costPrice = this.$method.checkInput(item.costPrice, 3)
          if (!this.$method.isEmptyOrZero(item.nums)) {
            item.totalPrice = this.$method.toFixed(item.costPrice * item.nums, 3)
          }
        } else if (type === 3) {
          item.totalPrice = this.$method.checkInput(item.totalPrice, 3)
          if (!this.$method.isEmptyOrZero(item.nums)) {
            item.costPrice = this.$method.toFixed(item.totalPrice / item.nums, 3)
          }
        }
      }
    },
    //保存
    clickSave() {
      if (this.selectStock === '' || this.selectStock === null || this.selectStockType === '' || this
          .selectStockType === null) {
        this.showRedBorder = true
        return
      }
      if (this.drugList.length === 0) {
        this.$message.error('请选择药品')
        return
      }
      //检查是否填写完整
      for (var i = 0; i < this.drugList.length; i++) {
        let item = this.drugList[i]
        if (item.nums === '' || item.nums === null) {
          this.$message.error('第' + (i + 1) + '行入库项目没有获取到数量')
          return
        }
      }
      let param = {
        pharmacyId: this.selectStock,
        type: this.selectStockType,
        supplierId: this.selectSupplier,
        remark: this.remark,
        details: this.drugList,
      }
      if (this.selectId !== '') {
        param.id = this.selectId
      }
      this.$postRequest('/admin/stock/addOutStorage', param).then((res) => {
        if (res) {
          this.$message.success(res.message)
          this.visibleEdit = false
          this.pageNo = 1
          this.getData()
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //获取库房列表
    getHouseList() {
      this.$getRequest('/admin/pharmacy/listAll', {}).then((res) => {
        if (res) {
          this.houseArray = res.data
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //获取出库类型
    getOutStorageType() {
      this.$getRequest('/admin/dict/getOutStorageType', {}).then((res) => {
        if (res) {
          this.typeArray = res.data
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //获取出库单
    getData() {
      this.$getRequest('/admin/stock/pageOutStorage', {
        pharmacyId: this.selectHouse,
        type: this.selectType,
        start: this.selectDate[0] ? this.selectDate[0] : '',
        end: this.selectDate[1] ? this.selectDate[1] : '',
        batchNo: this.orderNum,
        pageNumber: this.pageNo,
      }).then((res) => {
        if (res) {
          this.total = res.data.totalRow
          this.tableData = res.data.list
        }
      }).catch((error) => {
        console.log(error)
      })
    },
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {},
}
</script>

<style lang="scss" scoped>
.outStock {
  height: 100%;

  .card-div {
    margin: 20px;
    background: #FFFFFF;
    box-shadow: 0 0 5px #F3F3F3;
    border-radius: 3px;
    padding: 20px;
    overflow: auto;
  }

  .dialog-content {
    height: 80vh;
  }
}
</style>
